import { Configuration, OpenAIApi } from 'openai';

import FormSection from './components/FormSection';
import AnswerSection from './components/AnswerSection';

import { useState } from 'react';

const App = () => {
  const configuration = new Configuration({
    apiKey: "sk-or-vv-9a433b6e271f8a78752bf7050afc0a779ad12894eb069483ae310a8aaa9f7bc2",
    basePath: "https://api.vsegpt.ru:6070/v1",
  });

  const openai = new OpenAIApi(configuration);

    const [storedValues, setStoredValues] = useState([]);
    const [assistantMessages, setAssistantMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const generateResponse = async (newQuestion, setNewQuestion) => {
    if (newQuestion.trim().length === 0) { // Проверяем, что вопрос не пустой
    return; // Возвращаем функцию, если вопрос пустой
    }
    if (!isLoading) { // Проверяем, не загружается ли уже ответ
      setIsLoading(true); // Устанавливаем isLoading в true
  const sysPrompt = process.env.REACT_APP_SYSTEM_PROMPT;
  const messages = [
      ...assistantMessages,
      { role: "user", content: newQuestion },
    ];
  const completion = await openai.createChatCompletion({
      model: "openai/gpt-3.5-turbo-1106",
      temperature: 0.7,
      presence_penalty: -0.1,
      frequency_penalty: 0.1, 
      messages: [
        { role: "system", content: sysPrompt },
        ...messages,
      ],
    }); 

    if (completion.data.choices) {
      const newValues = [
        {
          question: newQuestion,
          answer: completion.data.choices[0].message.content,
        },
        ...storedValues,
      ];
      setStoredValues(newValues);
      setAssistantMessages([
        ...messages,
        { role: "assistant", content: completion.data.choices[0].message.content },
      ]);
      setNewQuestion('');
      setIsLoading(false); // Устанавливаем isLoading в false после получения ответа
      }
    }
    };

  return (
    <div>
      <div className="header-section"> 
        {storedValues.length < 1}
      </div>

      <FormSection generateResponse={generateResponse} isLoading={isLoading}/> 

      {storedValues.length > 0 && <AnswerSection storedValues={storedValues} />}
    </div>
  );
};

export default App;